import Vue from 'vue'

/**
 * Store action in queue
 * @param commit
 * @param action
 * @returns {Promise}
 */
export const pushAction = ({commit, state, dispatch}, {action}) => {
  oldSentry = null
  if (reloadTimeout) {
    clearTimeout(reloadTimeout)
  }
  commit('pushAction', {action})
  if (!state.isWorking) {
    commit('setIsWorking')
    dispatch('consumeQueue')
  }
}

let oldSentry = null
let reloadTimeout = null

export const consumeQueue = ({commit, state, dispatch, rootGetters}) => {
  console.assert(state.isWorking, 'Should work to comsume')
  if (state.queue.length) {
    const action = state.queue.shift()
    commit('setCurrentActionMessage', {message: `${action.label} - ${state.queue.length} left`})
    Vue.http[action.method](action.url, action.payload).then(({data: response}) => {
      if (response['Message'] !== 'Ok') {
        if (response.ErrorStatus === 'WebAuthModuleAsyncFailed') {
          dispatch('logout', null, {root: true})
        } else {
          dispatch('errors/pushError', {error: response.Message}, {root: true})
          console.error('Error: ', response.Message)
        }
      }
      dispatch('consumeQueue')
    }).catch(() => {
      dispatch('consumeQueue')
    })
  } else {
    commit('unsetIsWorking')
    commit('setCurrentActionMessage', {message: ''})
    const sentry = oldSentry = '' + Math.random()
    reloadTimeout = setTimeout(() => {
      dispatch('destiny/profile/reload', null, {root: true}).then(commitReload => {
        if (!state.isWorking && sentry === oldSentry) {
          commitReload()
          commit('setCurrentActionMessage', {message: ''})
        }
      })
    }, 2000)
  }
}



// WEBPACK FOOTER //
// ./src/store/queue/actions.js